import type { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const Logo: FC = () => {
  return (
    <StaticImage
      src='../../../content/images/logo.png'
      alt='Logo'
      objectFit='contain'
      style={{ display: 'flex' }}
      height={60}
    />
  );
};
